import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "패키지 및 태스크 그래프",
  "description": "Turborepo는 구성 및 리포지토리 구조를 기반으로 태스크 그래프를 구축합니다."
};
export let structuredData = {
  "contents": [{
    "heading": "패키지-그래프",
    "content": "패키지 그래프는 패키지 매니저에 의해 생성된 모노레포의 구조입니다. 내부 패키지를 서로 설치하면 Turborepo는 자동으로 해당 의존성 관계를 식별하여 워크스페이스에 대한 기본적인 이해를 구축합니다."
  }, {
    "heading": "패키지-그래프",
    "content": "이는 태스크가 서로 어떻게 관련되는지 정의할 태스크 그래프의 기초를 마련합니다."
  }, {
    "heading": "태스크-그래프",
    "content": "turbo.json에서 태스크가 서로 어떻게 관련되는지 표현합니다. 이러한 관계를 태스크 간의 의존성으로 생각할 수 있지만, 우리는 이를 위한 더 공식적인 이름인 태스크 그래프를 사용합니다."
  }, {
    "heading": "태스크-그래프",
    "content": "--graph 플래그를 사용하여 태스크의\n태스크 그래프 시각화를 생성할 수 있습니다."
  }, {
    "heading": "태스크-그래프",
    "content": "Turborepo는 리포지토리와 태스크를 이해하기 위해 방향성 비순환 그래프(DAG)라는 데이터 구조를 사용합니다. 그래프는 \"노드\"와 \"에지\"로 구성됩니다. 태스크 그래프에서 노드는 태스크이고 에지는 태스크 간의 의존성입니다. 방향성 그래프는 각 노드를 연결하는 에지에 방향이 있음을 나타내므로, 태스크 A가 태스크 B를 가리키면 태스크 A가 태스크 B에 의존한다고 말할 수 있습니다. 에지의 방향은 어떤 태스크가 어떤 태스크에 의존하는지에 따라 달라집니다."
  }, {
    "heading": "태스크-그래프",
    "content": "예를 들어, ./apps/web에 두 개의 패키지 @repo/ui와 @repo/utils에 의존하는 애플리케이션이 있는 모노레포가 있다고 가정해 봅시다:"
  }, {
    "heading": "태스크-그래프",
    "content": "^build에 의존하는 build 태스크도 있습니다:"
  }, {
    "heading": "태스크-그래프",
    "content": "Turborepo는 다음과 같은 태스크 그래프를 구축합니다:"
  }, {
    "heading": "transit-노드",
    "content": "태스크 그래프를 구축할 때의 과제는 중첩된 의존성을 처리하는 것입니다. 예를 들어, 모노레포에 ui 패키지에 의존하고, ui 패키지는 core 패키지에 의존하는 docs 앱이 있다고 가정해 봅시다:"
  }, {
    "heading": "transit-노드",
    "content": "docs 앱과 core 패키지는 각각 build 태스크를 가지고 있지만, ui 패키지는 가지고 있지 않다고 가정해 봅시다. 또한 위와 같이 \"dependsOn\": [\"^build\"]로 build 태스크를 구성하는 turbo.json이 있습니다. turbo run build를 실행하면 어떤 일이 일어날 것으로 예상하시나요?"
  }, {
    "heading": "transit-노드",
    "content": "Turborepo는 다음 태스크 그래프를 구축합니다:"
  }, {
    "heading": "transit-노드",
    "content": "이 그래프를 일련의 단계로 생각할 수 있습니다:"
  }, {
    "heading": "transit-노드",
    "content": "docs 앱은 ui에만 의존합니다."
  }, {
    "heading": "transit-노드",
    "content": "ui 패키지는 빌드 스크립트를 가지고 있지 않습니다."
  }, {
    "heading": "transit-노드",
    "content": "ui 패키지의 의존성은 build 스크립트를 가지고 있으므로 태스크 그래프는 이를 포함하는 것을 알고 있습니다."
  }, {
    "heading": "transit-노드",
    "content": "Turborepo는 이 시나리오에서 자체 build 스크립트를 가지고 있지 않기 때문에 ui 패키지를 Transit 노드라고 부릅니다. build 스크립트가 없기 때문에 Turborepo는 이를 위해 아무것도 실행하지 않지만, 자체 의존성을 포함하기 위한 목적으로 여전히 그래프의 일부입니다."
  }, {
    "heading": "진입점으로서의-transit-노드",
    "content": "docs/ 패키지가 build 태스크를 구현하지 않았다면 어떻게 될까요? 이 경우 어떤 일이 일어날 것으로 예상하시나요? ui 및 core 패키지가 여전히 빌드 태스크를 실행해야 할까요? 어떤 일이든 일어나야 할까요?"
  }, {
    "heading": "진입점으로서의-transit-노드",
    "content": "Turborepo의 정신 모델은 태스크 그래프의 모든 노드가 동일하다는 것입니다. 즉, Transit 노드는 그래프에서 어디에 나타나든 관계없이 그래프에 포함됩니다. 이 모델은 예상치 못한 결과를 가져올 수 있습니다. 예를 들어, build 태스크를 ^test에 의존하도록 구성했다고 가정해 봅시다:"
  }, {
    "heading": "진입점으로서의-transit-노드",
    "content": "모노레포에 많은 앱과 많은 패키지가 있다고 가정해 봅시다. 모든 패키지에는 test 태스크가 있지만 한 앱에만 build 태스크가 있습니다. Turborepo의 정신 모델에 따르면 turbo run build를 실행할 때 앱이 build를 구현하지 않더라도 의존성인 모든 패키지의 test 태스크가 그래프에 표시됩니다."
  }],
  "headings": [{
    "id": "패키지-그래프",
    "content": "패키지 그래프"
  }, {
    "id": "태스크-그래프",
    "content": "태스크 그래프"
  }, {
    "id": "transit-노드",
    "content": "Transit 노드"
  }, {
    "id": "진입점으로서의-transit-노드",
    "content": "진입점으로서의 Transit 노드"
  }]
};
import __img0 from "./../../../public/images/docs/simple-task-graph.png";
import __img1 from "./../../../public/images/docs/transitive-nodes.png";
import {File, Folder, Files} from '#components/files';
import {Callout} from '#components/callout';
export const toc = [{
  depth: 2,
  url: "#패키지-그래프",
  title: _jsx(_Fragment, {
    children: "패키지 그래프"
  })
}, {
  depth: 2,
  url: "#태스크-그래프",
  title: _jsx(_Fragment, {
    children: "태스크 그래프"
  })
}, {
  depth: 3,
  url: "#transit-노드",
  title: _jsx(_Fragment, {
    children: "Transit 노드"
  })
}, {
  depth: 4,
  url: "#진입점으로서의-transit-노드",
  title: _jsx(_Fragment, {
    children: "진입점으로서의 Transit 노드"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    img: "img",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      id: "패키지-그래프",
      children: "패키지 그래프"
    }), "\n", _jsxs(_components.p, {
      children: ["패키지 그래프는 패키지 매니저에 의해 생성된 모노레포의 구조입니다. ", _jsx(_components.a, {
        href: "/docs/core-concepts/internal-packages",
        children: "내부 패키지"
      }), "를 서로 설치하면 Turborepo는 자동으로 해당 의존성 관계를 식별하여 워크스페이스에 대한 기본적인 이해를 구축합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["이는 ", _jsx(_components.strong, {
        children: "태스크"
      }), "가 서로 어떻게 관련되는지 정의할 태스크 그래프의 기초를 마련합니다."]
    }), "\n", _jsx(_components.h2, {
      id: "태스크-그래프",
      children: "태스크 그래프"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo.json"
      }), "에서 태스크가 서로 어떻게 관련되는지 표현합니다. 이러한 관계를 태스크 간의 의존성으로 생각할 수 있지만, 우리는 이를 위한 더 공식적인 이름인 태스크 그래프를 사용합니다."]
    }), "\n", _jsx(Callout, {
      type: "good-to-know",
      children: _jsxs(_components.p, {
        children: [_jsxs(_components.a, {
          href: "/docs/reference/run#--graph-file-type",
          children: [_jsx(_components.code, {
            children: "--graph"
          }), " 플래그"]
        }), "를 사용하여 태스크의\n태스크 그래프 시각화를 생성할 수 있습니다."]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo는 리포지토리와 태스크를 이해하기 위해 ", _jsx(_components.a, {
        href: "https://en.wikipedia.org/wiki/Directed_acyclic_graph",
        children: "방향성 비순환 그래프(DAG)"
      }), "라는 데이터 구조를 사용합니다. 그래프는 \"노드\"와 \"에지\"로 구성됩니다. 태스크 그래프에서 노드는 태스크이고 에지는 태스크 간의 의존성입니다. ", _jsx(_components.em, {
        children: "방향성"
      }), " 그래프는 각 노드를 연결하는 에지에 방향이 있음을 나타내므로, 태스크 A가 태스크 B를 가리키면 태스크 A가 태스크 B에 의존한다고 말할 수 있습니다. 에지의 방향은 어떤 태스크가 어떤 태스크에 의존하는지에 따라 달라집니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["예를 들어, ", _jsx(_components.code, {
        children: "./apps/web"
      }), "에 두 개의 패키지 ", _jsx(_components.code, {
        children: "@repo/ui"
      }), "와 ", _jsx(_components.code, {
        children: "@repo/utils"
      }), "에 의존하는 애플리케이션이 있는 모노레포가 있다고 가정해 봅시다:"]
    }), "\n", _jsxs(Files, {
      children: [_jsx(Folder, {
        name: "apps",
        defaultOpen: true,
        children: _jsx(Folder, {
          name: "web"
        })
      }), _jsxs(Folder, {
        name: "packages",
        defaultOpen: true,
        children: [_jsx(Folder, {
          name: "ui"
        }), _jsx(Folder, {
          name: "utils"
        })]
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "^build"
      }), "에 의존하는 ", _jsx(_components.code, {
        children: "build"
      }), " 태스크도 있습니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"^build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "Turborepo는 다음과 같은 태스크 그래프를 구축합니다:"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        alt: "태스크 그래프 시각화. 다이어그램에는 \"apps/web\"이라는 상단 노드가 있고, 각각 \"packages/ui\"와 \"packages/utils\" 노드에 연결되는 두 개의 선이 있습니다.",
        placeholder: "blur",
        src: __img0
      })
    }), "\n", _jsx(_components.h3, {
      id: "transit-노드",
      children: "Transit 노드"
    }), "\n", _jsxs(_components.p, {
      children: ["태스크 그래프를 구축할 때의 과제는 중첩된 의존성을 처리하는 것입니다. 예를 들어, 모노레포에 ", _jsx(_components.code, {
        children: "ui"
      }), " 패키지에 의존하고, ", _jsx(_components.code, {
        children: "ui"
      }), " 패키지는 ", _jsx(_components.code, {
        children: "core"
      }), " 패키지에 의존하는 ", _jsx(_components.code, {
        children: "docs"
      }), " 앱이 있다고 가정해 봅시다:"]
    }), "\n", _jsxs(Files, {
      children: [_jsx(Folder, {
        name: "apps",
        defaultOpen: true,
        children: _jsx(Folder, {
          name: "docs"
        })
      }), _jsxs(Folder, {
        name: "packages",
        defaultOpen: true,
        children: [_jsx(Folder, {
          name: "ui"
        }), _jsx(Folder, {
          name: "core"
        })]
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "docs"
      }), " 앱과 ", _jsx(_components.code, {
        children: "core"
      }), " 패키지는 각각 ", _jsx(_components.code, {
        children: "build"
      }), " 태스크를 가지고 있지만, ", _jsx(_components.code, {
        children: "ui"
      }), " 패키지는 가지고 있지 않다고 가정해 봅시다. 또한 위와 같이 ", _jsx(_components.code, {
        children: "\"dependsOn\": [\"^build\"]"
      }), "로 ", _jsx(_components.code, {
        children: "build"
      }), " 태스크를 구성하는 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "이 있습니다. ", _jsx(_components.code, {
        children: "turbo run build"
      }), "를 실행하면 어떤 일이 일어날 것으로 예상하시나요?"]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo는 다음 태스크 그래프를 구축합니다:"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        alt: "Transit 노드가 있는 태스크 그래프 시각화. 다이어그램에는 \"apps/doc\"이라는 상단 노드가 있고 \"packages/ui\" 노드에 연결되는 선이 있습니다. 이 노드에는 \"build\" 태스크가 없습니다. \"packages/ui\" 노드에는 \"build\" 태스크가 있는 \"packages/core\" 노드로 연결되는 또 다른 선이 있습니다.",
        placeholder: "blur",
        src: __img1
      })
    }), "\n", _jsx(_components.p, {
      children: "이 그래프를 일련의 단계로 생각할 수 있습니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "docs"
        }), " 앱은 ", _jsx(_components.code, {
          children: "ui"
        }), "에만 의존합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "ui"
        }), " 패키지는 빌드 스크립트를 가지고 ", _jsx(_components.strong, {
          children: "있지 않습니다"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "ui"
        }), " 패키지의 ", _jsx(_components.em, {
          children: "의존성"
        }), "은 ", _jsx(_components.code, {
          children: "build"
        }), " 스크립트를 가지고 있으므로 태스크 그래프는 이를 포함하는 것을 알고 있습니다."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo는 이 시나리오에서 자체 ", _jsx(_components.code, {
        children: "build"
      }), " 스크립트를 가지고 있지 않기 때문에 ", _jsx(_components.code, {
        children: "ui"
      }), " 패키지를 Transit 노드라고 부릅니다. ", _jsx(_components.code, {
        children: "build"
      }), " 스크립트가 없기 때문에 Turborepo는 이를 위해 아무것도 실행하지 않지만, 자체 의존성을 포함하기 위한 목적으로 여전히 그래프의 일부입니다."]
    }), "\n", _jsx(_components.h4, {
      id: "진입점으로서의-transit-노드",
      children: "진입점으로서의 Transit 노드"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "docs/"
      }), " 패키지가 ", _jsx(_components.code, {
        children: "build"
      }), " 태스크를 구현하지 않았다면 어떻게 될까요? 이 경우 어떤 일이 일어날 것으로 예상하시나요? ", _jsx(_components.code, {
        children: "ui"
      }), " 및 ", _jsx(_components.code, {
        children: "core"
      }), " 패키지가 여전히 빌드 태스크를 실행해야 할까요? ", _jsx(_components.em, {
        children: "어떤 일이든"
      }), " 일어나야 할까요?"]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo의 정신 모델은 태스크 그래프의 모든 노드가 동일하다는 것입니다. 즉, Transit 노드는 그래프에서 어디에 나타나든 관계없이 그래프에 포함됩니다. 이 모델은 예상치 못한 결과를 가져올 수 있습니다. 예를 들어, ", _jsx(_components.code, {
        children: "build"
      }), " 태스크를 ", _jsx(_components.code, {
        children: "^test"
      }), "에 의존하도록 구성했다고 가정해 봅시다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"^test\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["모노레포에 많은 앱과 많은 패키지가 있다고 가정해 봅시다. 모든 패키지에는 ", _jsx(_components.code, {
        children: "test"
      }), " 태스크가 있지만 한 앱에만 ", _jsx(_components.code, {
        children: "build"
      }), " 태스크가 있습니다. Turborepo의 정신 모델에 따르면 ", _jsx(_components.code, {
        children: "turbo run build"
      }), "를 실행할 때 앱이 ", _jsx(_components.code, {
        children: "build"
      }), "를 구현하지 않더라도 의존성인 모든 패키지의 ", _jsx(_components.code, {
        children: "test"
      }), " 태스크가 그래프에 표시됩니다."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
